import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';

@Component({
	selector: 'app-scatter-plot-chart',
	templateUrl: './scatter-plot-chart.component.html',
	styleUrls: ['./scatter-plot-chart.component.css']
})
export class ScatterPlotChartComponent implements OnInit {
	@ViewChild('scatterChartElement', { static: true }) graphElement: ElementRef;

	public chartConfigurationObj: any;

	@Input() scatterconfiguration: any;
	@Input() seriesData: any;
	public categories = [
		'2020-01-02',
		'2020-01-03',
		'2020-01-04',
		'2020-01-05',
		'2020-01-06',
		'2020-01-07',
		'2020-01-08'
	];

	constructor() {}

	ngOnInit() {
		this.chartConfigurationObj = JSON.parse(decodeURI(this.scatterconfiguration));
		this.renderChart();
	}

	renderChart() {
		Highcharts.chart({
			chart: {
				type: 'scatter',
				width: this.chartConfigurationObj.graphConfig.width,
				height: this.chartConfigurationObj.graphConfig.height,
				renderTo: this.graphElement.nativeElement,
				backgroundColor: 'transparent',
				margin: this.chartConfigurationObj.graphConfig.margin || [40, 10, 10, 10]
			},
			title: {
				text: this.chartConfigurationObj.graphConfig.title ? this.chartConfigurationObj.graphConfig.title : ''
			},
			subtitle: {
				text: this.chartConfigurationObj.graphConfig.subTitle ? this.chartConfigurationObj.graphConfig.subTitle : ''
			},
			// tooltip: this.chartConfigurationObj.tooltip ? this.chartConfigurationObj.tooltip : this.tooltip,
			credits: {
				enabled: false
			},
			plotOptions: {
				scatter: {
					marker: {
						symbol: this.chartConfigurationObj.plotOptions.marker.symbol
							? this.chartConfigurationObj.plotOptions.marker.symbol
							: 'circle',
						radius: this.chartConfigurationObj.plotOptions.marker.radius
							? this.chartConfigurationObj.plotOptions.marker.radius
							: 4,
						height: this.chartConfigurationObj.plotOptions.marker.height
							? this.chartConfigurationObj.plotOptions.marker.height
							: null,
						width: this.chartConfigurationObj.plotOptions.marker.width
							? this.chartConfigurationObj.plotOptions.marker.width
							: null
					}
				}
			},
			legend: {
				align: this.chartConfigurationObj.legend.align ? this.chartConfigurationObj.legend.align : 'center',
				layout: this.chartConfigurationObj.legend.layout ? this.chartConfigurationObj.legend.layout : 'horizontal',
				enabled: this.chartConfigurationObj.legend.enabled ? this.chartConfigurationObj.legend.enabled : true,
				verticalAlign: this.chartConfigurationObj.legend.verticalAlign || 'top',
				x: this.chartConfigurationObj.legend.x || -15,
				y: this.chartConfigurationObj.legend.y || null,
				width: this.chartConfigurationObj.legend.width || null,
				itemDistance: this.chartConfigurationObj.legend.itemDistance || 20,
				itemStyle: this.chartConfigurationObj.legend.itemStyle || null
			},
			xAxis: {
				categories: this.buildCategories(this.categories),
				labels: {
					step: this.chartConfigurationObj.xaxis.stepCount || 1,
					y: this.chartConfigurationObj.xaxis.xaxisLabely || undefined,
					style: this.chartConfigurationObj.xaxis.xAxisLabelStyle
						? this.chartConfigurationObj.xaxis.xAxisLabelStyle
						: {}
				},
				tickmarkPlacement: this.chartConfigurationObj.xaxis.tickmarkPlacement || 'between',
				tickWidth: this.chartConfigurationObj.xaxis.tickWidth || 1,
				tickColor: this.chartConfigurationObj.xaxis.tickColor || '#ccd6eb'
			},
			yAxis: this.chartConfigurationObj.yAxis,
			series: this.seriesData
		});
	}

	buildCategories(data) {
		const dates = data.map((x) => {
			x = moment(x, 'YYYY-MM-DD').format(this.chartConfigurationObj.xaxis.format);
			return x;
		});
		return dates;
	}

	buildToolTip() {}
	buildYaxis() {}
}
